import styled, { css } from 'styled-components';

const ToggleReadMore = styled.span`
  height: 21px;
  display: flex;
  cursor: pointer;
  align-items: center;
  ${({ theme, withLineHeight, withReadMore }) =>
    css`
      line-height: ${withLineHeight}px;
      color: ${theme.colors.night_blue_1};
      width: ${withReadMore ? '60px' : '76px'};
      ${theme.fontFamily.secondaryFont.xSmallBold};
    `}
`;

export default ToggleReadMore;
